/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
	/*-------------------------------------------------------------
	*
	* Slider
	*
	*-------------------------------------------------------------*/

	// Slick
	jQuery('.flex-slider').slick({
		dots: false,
		infinite: true,
		speed: 3000,
		autoplay:true,
		// autoplaySpeed: 30,
		pauseOnHover: false,
		fade:true,
		arrows: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 600,
				settings: {
          arrows: false,
				}
			},
			{
				breakpoint: 480,
				settings: {
          arrows: false,
					autoplay:false
				}
			}
		]
	});

	// Slick
	jQuery('.flex-carousel').slick({
		dots: false,
		infinite: true,
		speed: 300,
		//autoplay:true,
		//autoplaySpeed: 5000,
		arrows: true,
		slidesToShow: 2,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					adaptiveHeight: true,
					autoplay:false
				}
			}
		]
	});

	// Slick
	jQuery('.flex-carousel-accreditations').slick({
		dots: false,
		infinite: true,
		speed: 300,
		autoplay:true,
		autoplaySpeed: 5000,
		arrows: false,
		slidesToShow: 5,
		slidesToScroll: 5,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4,
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					adaptiveHeight: true,
					autoplay:false
				}
			}
		]
	});

	jQuery('.flex-slider').show();
	jQuery('.flex-carousel').show();
	jQuery('.flex-home-carousel').show();
	jQuery('.flex-carousel-accreditations').show();


	/*-------------------------------------------------------------
	*
	* Scroll to top
	*
	*-------------------------------------------------------------*/
	jQuery(window).scroll(function(){
		if (jQuery(this).scrollTop() > 100) {
			jQuery('.scrollup').fadeIn();
		} else {
			jQuery('.scrollup').fadeOut();
		}
	});

	jQuery('.scrollup').click(function(){
		jQuery("html, body").animate({ scrollTop: 0 }, 600);
		return false;
	});
	/*-------------------------------------------------------------
	*
	* End document ready
	*
	*-------------------------------------------------------------*/
});
